export enum AccessTypes{
  Private = 'private',
  Public = 'public',
  AllAccount = 'all-account',
  Account = 'account'
}
